import type { Activity, ItemsConfig, IPositionsConfig } from '@/scripts/data/types'
import { pages } from './settings'

// Global state used for storing preprocessed data that needs to be accessed by multiple modules
export const GlobalState = {
  activities: [] as Activity[],
  pages, // Pages are processed in settings.ts
  itemsConfig: {} as ItemsConfig,
  positionsConfig: {} as IPositionsConfig,
}
